var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "info-head spaceBetween" },
      [
        _c("span", [_vm._v("Personal Verification")]),
        _vm._v(" "),
        _c("el-button", {
          attrs: {
            type: "text",
            icon: _vm.isOpen ? "el-icon-arrow-up" : "el-icon-arrow-down",
          },
          on: {
            click: function ($event) {
              _vm.isOpen = !_vm.isOpen
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen",
          },
        ],
        attrs: { slot: "body" },
        slot: "body",
      },
      [
        _c(_vm.areaComp[_vm.area], {
          tag: "component",
          attrs: {
            PersonInfo: _vm.PersonInfo,
            NationalIds: _vm.NationalIds,
            Location: _vm.Location,
          },
          on: {
            "update:PersonInfo": function ($event) {
              _vm.PersonInfo = $event
            },
            "update:person-info": function ($event) {
              _vm.PersonInfo = $event
            },
            "update:NationalIds": function ($event) {
              _vm.NationalIds = $event
            },
            "update:national-ids": function ($event) {
              _vm.NationalIds = $event
            },
            "update:Location": function ($event) {
              _vm.Location = $event
            },
            "update:location": function ($event) {
              _vm.Location = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }